var DealsGTMHelper;

module.exports = DealsGTMHelper = {
  update: function(params) {
    var category2, category3, dlUpdate;
    category2 = params.category2, category3 = params.category3;
    if (window.dataLayer != null) {
      dlUpdate = {
        event: 'cat-nav'
      };
      window.dataLayer.push(['dl_categories.splice', 1, 2]);
      dlUpdate.dl_category_sub = category2 || '';
      if (category2 != null) {
        window.dataLayer.push(['dl_categories.push', category2]);
      }
      if (category3 != null) {
        window.dataLayer.push(['dl_categories.push', category3]);
      }
      return window.dataLayer.push(dlUpdate);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2RlYWxzL2Zyb250ZW5kL2hlbHBlcnMvZ3RtLXVwZGF0ZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9hZGNhYmFsbGVyby9uYXBpc3RyYW5vL2J1aWxkLzE0OTI0Njc5NzUzNzktMzc5NTIvc3RhZ2luZy0yMDE3LjA0LjE3XzIyLjE1L2dvb2RzL21vZHVsZXMvZGVhbHMvZnJvbnRlbmQvaGVscGVycy9ndG0tdXBkYXRlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLGNBQUEsR0FBaUI7RUFBQSxNQUFBLEVBQVEsU0FBQyxNQUFEO0FBQ3hDLFFBQUE7SUFBQyw0QkFBRCxFQUFZO0lBQ1osSUFBRyx3QkFBSDtNQUNFLFFBQUEsR0FDRTtRQUFBLEtBQUEsRUFBTyxTQUFQOztNQUVGLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBakIsQ0FBc0IsQ0FBQyxzQkFBRCxFQUF5QixDQUF6QixFQUE0QixDQUE1QixDQUF0QjtNQUNBLFFBQVEsQ0FBQyxlQUFULEdBQTJCLFNBQUEsSUFBYTtNQUV4QyxJQUFHLGlCQUFIO1FBQ0UsTUFBTSxDQUFDLFNBQVMsQ0FBQyxJQUFqQixDQUFzQixDQUFDLG9CQUFELEVBQXVCLFNBQXZCLENBQXRCLEVBREY7O01BR0EsSUFBRyxpQkFBSDtRQUNFLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBakIsQ0FBc0IsQ0FBQyxvQkFBRCxFQUF1QixTQUF2QixDQUF0QixFQURGOzthQUdBLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBakIsQ0FBc0IsUUFBdEIsRUFiRjs7RUFGd0MsQ0FBUiJ9
